import { render, staticRenderFns } from "./couponAdd.vue?vue&type=template&id=a585b0d2&scoped=true&"
import script from "./couponAdd.vue?vue&type=script&lang=js&"
export * from "./couponAdd.vue?vue&type=script&lang=js&"
import style0 from "./couponAdd.vue?vue&type=style&index=0&id=a585b0d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a585b0d2",
  null
  
)

export default component.exports